import Reflux from "reflux";

export const CustomerDataActions = {
	reloadCustomerData: Reflux.createAction(["reloadCustomerData"]),
};
